// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {132: "160d3024e7eb7c3e",491: "c3c199ffa835860d",769: "bd7640cd52d0e4ae",818: "5ec9d2ae7ccae0d9",}[chunkId] + ".css"
}